import { Bar } from "react-chartjs-2"
import React, { FunctionComponent } from "react"
import { ChartData, ChartOptions, DefaultDataPoint } from "chart.js"
import { binomialSample } from "@components/Distribution/BinomialDistributionChart/binomial.calc"

interface Props {
  n: number
  p: number
  lbound?: number
  ubound?: number
}

export const BinomialDistributionChart: FunctionComponent<Props> = ({
  n = 1,
  p = 0.5,
  lbound = undefined,
  ubound = undefined,
}) => {
  const { data, labels } = binomialSample(n, p, lbound, ubound)

  const chartData: ChartData<"bar", DefaultDataPoint<"bar">, number> = {
    labels,
    datasets: [
      {
        data,
        borderWidth: 1,
        barPercentage: 1.0,
        categoryPercentage: 1.0,
      },
    ],
  }

  const chartOptions: ChartOptions<"bar"> = {
    maintainAspectRatio: true,
    responsive: true,
    scales: {
      x: {
        title: {
          display: true,
          text: "Number of Successes",
        },
      },
      y: {
        title: {
          display: true,
          text: "Probability",
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
  }

  return <Bar options={chartOptions} data={chartData}></Bar>
}
